import { render } from "./Malhas.vue?vue&type=template&id=07e513c1&scoped=true"
import script from "./Malhas.vue?vue&type=script&lang=js"
export * from "./Malhas.vue?vue&type=script&lang=js"

import "./Malhas.vue?vue&type=style&index=0&id=07e513c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e513c1"]])

export default __exports__